const vi = {
  // Sidebar
  "sidebar.brand": "OmniSport",
  "nav.classesMgmt": "Lớp học",
  "nav.sessions": "Buổi học",
  "nav.members": "Học viên",
  "nav.staff": "Nhân viên",
  "nav.schedule": "Lịch học",
  "nav.teachingCourses": "Lớp học phụ trách",
  "nav.teachingSchedule": "Lịch dạy",
  "nav.assignedClasses": "Lớp phụ trách",
  "nav.dashboard": "Tổng quan",
  "nav.signIn": "Đăng nhập",

  // Navbar
  "navbar.pages": "Trang",
  "navbar.search": "Tìm kiếm...",
  "navbar.notification": "Thông báo",
  "navbar.markAllRead": "Đánh dấu đã đọc",
  "navbar.noNotifications": "Không có thông báo mới",
  "navbar.sendNotification": "Gửi thông báo",
  "navbar.notificationSent": "Đã gửi thông báo thành công",
  "navbar.notificationFailed": "Gửi thông báo thất bại",
  "navbar.greeting": "Chào",
  "navbar.profileSettings": "Cài đặt hồ sơ",
  "navbar.newsletterSettings": "Cài đặt bản tin",
  "navbar.logout": "Đăng xuất",

  // Dashboard Widgets
  "widget.earnings": "Doanh thu",
  "widget.spendThisMonth": "Chi tiêu tháng này",
  "widget.sales": "Doanh số",
  "widget.yourBalance": "Số dư",
  "widget.newTasks": "Công việc mới",
  "widget.totalProjects": "Tổng dự án",

  // Dashboard Components
  "dashboard.systemStats": "Thống kê hệ thống",
  "dashboard.centerStats": "Thống kê trung tâm",
  "dashboard.totalUsers": "Tổng người dùng",
  "dashboard.totalStudents": "Học viên",
  "dashboard.totalTrainers": "Huấn luyện viên",
  "dashboard.totalTeachers": "Quản lý lớp",
  "dashboard.totalManagers": "Quản lý trung tâm",
  "dashboard.totalCenters": "Trung tâm",
  "dashboard.totalClasses": "Lớp học",
  "dashboard.totalSessions": "Buổi học",
  "dashboard.totalSpent": "Tổng chi tiêu",
  "dashboard.thisMonth": "Tháng này",
  "dashboard.weeklyRevenue": "Doanh thu tuần",
  "dashboard.dailyTraffic": "Lượt truy cập hàng ngày",
  "dashboard.visitors": "Lượt khách",
  "dashboard.yourPieChart": "Biểu đồ tròn",
  "dashboard.monthly": "Theo tháng",
  "dashboard.yearly": "Theo năm",
  "dashboard.weekly": "Theo tuần",
  "dashboard.yourFiles": "Tệp của bạn",
  "dashboard.system": "Hệ thống",
  "dashboard.tasks": "Công việc",
  "dashboard.checkTable": "Bảng kiểm tra",
  "dashboard.complexTable": "Bảng phức hợp",

  // Table Headers
  "table.name": "TÊN",
  "table.status": "TRẠNG THÁI",
  "table.date": "NGÀY",
  "table.progress": "TIẾN ĐỘ",
  "table.quantity": "SỐ LƯỢNG",
  "table.tech": "CÔNG NGHỆ",
  "table.artworks": "TÁC PHẨM",
  "table.rating": "ĐÁNH GIÁ",
  "table.columnsTable": "Bảng 4 cột",
  "table.seeAll": "Xem tất cả",

  // Table Status
  "status.approved": "Đã duyệt",
  "status.disable": "Vô hiệu",
  "status.error": "Lỗi",

  // Marketplace / Classes
  "marketplace.trending": "Lớp học nổi bật",
  "marketplace.art": "Nghệ thuật",
  "marketplace.music": "Âm nhạc",
  "marketplace.collection": "Bộ sưu tập",
  "marketplace.sports": "Thể thao",
  "marketplace.recentlyAdded": "Mới thêm gần đây",
  "marketplace.discoverTitle": "Khám phá và đăng ký các lớp thể thao tuyệt vời",
  "marketplace.discoverDesc":
    "Bước vào thế giới thể thao năng động. Khám phá các lớp học mới nhất hoặc bắt đầu hành trình của bạn!",
  "marketplace.discoverNow": "Khám phá ngay",
  "marketplace.watchVideo": "Xem video",
  "marketplace.history": "Lịch sử",

  // Profile
  "profile.posts": "Bài viết",
  "profile.followers": "Người theo dõi",
  "profile.following": "Đang theo dõi",
  "profile.generalInfo": "Thông tin chung",
  "profile.education": "Học vấn",
  "profile.languages": "Ngôn ngữ",
  "profile.department": "Phòng ban",
  "profile.workHistory": "Lịch sử công tác",
  "profile.organization": "Tổ chức",
  "profile.birthday": "Ngày sinh",
  "profile.notifications": "Thông báo",
  "profile.allProjects": "Tất cả dự án",
  "profile.seeProductDetails": "Xem chi tiết",
  "profile.yourStorage": "Bộ nhớ của bạn",
  "profile.storageDesc": "Quản lý dung lượng ổ đĩa một cách dễ dàng",
  "profile.uploadFiles": "Tải tệp lên",
  "profile.uploadHint": "Chấp nhận tệp PNG, JPG và GIF",
  "profile.completeProfile": "Hoàn thiện hồ sơ",
  "profile.completeProfileDesc":
    "Luôn theo dõi các dự án với bảng trực tuyến để lên kế hoạch, phối hợp và thảo luận",
  "profile.publishNow": "Đăng ngay",

  // Profile Notifications
  "profile.notif.itemComment": "Thông báo bình luận",
  "profile.notif.buyerReview": "Thông báo đánh giá",
  "profile.notif.ratingReminder": "Nhắc nhở đánh giá",
  "profile.notif.meetups": "Sự kiện gần bạn",
  "profile.notif.companyNews": "Tin tức công ty",
  "profile.notif.newLaunches": "Ra mắt và dự án mới",
  "profile.notif.monthlyChanges": "Thay đổi sản phẩm hàng tháng",
  "profile.notif.newsletter": "Đăng ký bản tin",
  "profile.notif.emailFollow": "Email khi có người theo dõi tôi",

  // Auth - Sign In
  "auth.signIn": "Đăng nhập",
  "auth.signInSubtitle": "Nhập email và mật khẩu để đăng nhập!",
  "auth.signInGoogle": "Đăng nhập với Google",
  "auth.or": "hoặc",
  "auth.email": "Email*",
  "auth.emailPlaceholder": "email@omnisport.vn",
  "auth.password": "Mật khẩu*",
  "auth.passwordPlaceholder": "Tối thiểu 8 ký tự",
  "auth.keepLoggedIn": "Duy trì đăng nhập",
  "auth.forgotPassword": "Quên mật khẩu?",
  "auth.notRegistered": "Chưa có tài khoản?",
  "auth.createAccount": "Tạo tài khoản",
  "auth.signingIn": "Đang đăng nhập...",
  "auth.loginError": "Đăng nhập thất bại",
  "auth.networkError":
    "Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng.",
  "auth.invalidCredentials": "Tên đăng nhập hoặc mật khẩu không đúng",
  "auth.identifier": "Email, số điện thoại hoặc tên đăng nhập*",
  "auth.identifierPlaceholder": "Email, SĐT hoặc tên đăng nhập",
  "auth.signInPhoneSubtitle":
    "Đăng nhập bằng email, số điện thoại hoặc tên đăng nhập",

  // Class Management
  "class.title": "Quản lý lớp học",

  // Schedule
  "schedule.title": "Lịch học",
  "schedule.today": "Hôm nay",
  "schedule.month": "Tháng",
  "schedule.week": "Tuần",
  "schedule.day": "Ngày",
  "schedule.list": "Danh sách",
  "schedule.createEvent": "Tạo lịch học",
  "schedule.editEvent": "Chỉnh sửa lịch học",
  "schedule.eventName": "Tên buổi học",
  "schedule.eventNamePlaceholder": "VD: Bơi lội cơ bản A1",
  "schedule.startTime": "Bắt đầu",
  "schedule.endTime": "Kết thúc",
  "schedule.coach": "Quản lý lớp",
  "schedule.coachPlaceholder": "Nhập tên quản lý lớp",
  "schedule.location": "Địa điểm",
  "schedule.locationPlaceholder": "VD: Hồ bơi A, Sân B...",
  "schedule.color": "Màu sắc",
  "schedule.time": "Thời gian",
  "schedule.cancel": "Hủy",
  "schedule.create": "Tạo",
  "schedule.save": "Lưu",
  "schedule.delete": "Xóa",
  "schedule.edit": "Sửa",

  "class.createBtn": "Tạo lớp học",
  "class.createTitle": "Tạo lớp học mới",
  "class.className": "Tên lớp học",
  "class.classNamePlaceholder": "Nhập tên lớp học",
  "class.colName": "TÊN LỚP",
  "class.colSport": "MÔN",
  "class.colManager": "QUẢN LÝ LỚP",
  "class.colCoach": "QUẢN LÝ LỚP",
  "class.colStudents": "HỌC VIÊN",
  "class.colSchedule": "LỊCH HỌC",
  "class.colStatus": "TRẠNG THÁI",
  "class.maxStudents": "Sĩ số tối đa",
  "class.sportPlaceholder": "VD: Bơi lội, Yoga...",
  "class.managerPlaceholder": "Nhập tên quản lý lớp",
  "class.coachPlaceholder": "Nhập tên quản lý lớp",
  "class.schedulePlaceholder": "VD: Thứ 2, 4, 6 - 17:00",
  "class.statusOpen": "Đang mở",
  "class.statusFull": "Đã đầy",
  "class.statusClosed": "Đã đóng",
  "class.cancel": "Hủy",
  "class.create": "Tạo",
  "class.backToList": "Quay lại danh sách",
  "class.studentList": "Danh sách học viên",
  "class.noStudents": "Chưa có học viên nào",

  // Staff Management
  "staff.title": "Quản lý nhân viên",
  "staff.colName": "HỌ TÊN",
  "staff.colRole": "VỊ TRÍ",
  "staff.colPhone": "SĐT",
  "staff.colEmail": "EMAIL",
  "staff.colStatus": "TRẠNG THÁI",
  "staff.colJoinDate": "NGÀY VÀO",

  // Profile Settings
  "nav.settings": "Hồ sơ của tôi",
  "nav.userSessions": "Tra cứu học viên",
  "nav.staffAttendance": "Bảng chấm công",
  "nav.leaveRequests": "Đơn xin nghỉ phép",
  "settings.title": "Cài đặt hồ sơ",
  "settings.personalInfo": "Thông tin cá nhân",
  "settings.identityInfo": "Thông tin định danh",
  "settings.contactInfo": "Thông tin liên hệ",
  "settings.physicalInfo": "Thông tin thể chất",
  "settings.avatar": "Ảnh đại diện",
  "settings.changeAvatar": "Thay đổi ảnh",
  "settings.removeAvatar": "Xóa ảnh",
  "settings.fullName": "Họ và tên",
  "settings.fullNamePlaceholder": "Nhập họ và tên đầy đủ",
  "settings.nickname": "Biệt danh",
  "settings.nicknamePlaceholder": "Nhập biệt danh",
  "settings.gender": "Giới tính",
  "settings.male": "Nam",
  "settings.female": "Nữ",
  "settings.other": "Khác",
  "settings.dob": "Ngày sinh",
  "settings.dobPlaceholder": "dd/mm/yyyy",
  "settings.hometown": "Quê quán",
  "settings.hometownPlaceholder": "Nhập quê quán",
  "settings.bio": "Giới thiệu bản thân",
  "settings.bioPlaceholder": "Viết vài dòng về bản thân...",
  "settings.height": "Chiều cao (cm)",
  "settings.heightPlaceholder": "VD: 170",
  "settings.weight": "Cân nặng (kg)",
  "settings.weightPlaceholder": "VD: 65",
  "settings.idCardFront": "Ảnh CCCD mặt trước",
  "settings.idCardBack": "Ảnh CCCD mặt sau",
  "settings.idCardNumber": "Số CCCD",
  "settings.idCardNumberPlaceholder": "Nhập số căn cước công dân",
  "settings.idCardDate": "Ngày cấp",
  "settings.idCardPlace": "Nơi cấp",
  "settings.idCardPlacePlaceholder": "Nhập nơi cấp",
  "settings.uploadImage": "Tải ảnh lên",
  "settings.dragOrClick": "Kéo thả hoặc nhấn để chọn ảnh",
  "settings.imageHint": "PNG, JPG tối đa 5MB",
  "settings.email": "Email",
  "settings.emailPlaceholder": "email@omnisport.vn",
  "settings.phone": "Số điện thoại",
  "settings.phonePlaceholder": "0xxx xxx xxx",
  "settings.address": "Địa chỉ",
  "settings.addressPlaceholder": "Nhập địa chỉ đầy đủ",
  "settings.save": "Lưu thay đổi",
  "settings.cancel": "Hủy",
  "settings.edit": "Chỉnh sửa",
  "settings.noImage": "Chưa có ảnh",
  "settings.saveSuccess": "Đã lưu thành công!",

  // Certificates & Achievements
  "settings.certificates": "Chứng chỉ",
  "settings.certificate": "Chứng chỉ",
  "settings.noCertificates": "Chưa có chứng chỉ nào",
  "settings.certNamePlaceholder": "Nhập tên chứng chỉ",
  "settings.addCertificate": "Thêm chứng chỉ",
  "settings.achievements": "Thành tích",
  "settings.achievement": "Thành tích",
  "settings.noAchievements": "Chưa có thành tích nào",
  "settings.achievementNamePlaceholder": "Nhập tên thành tích",
  "settings.addAchievement": "Thêm thành tích",
  "settings.attachFiles": "Đính kèm tệp",

  // Footer
  "footer.poweredBy": "Được phát triển bởi",
  "footer.allRightsReserved": "Bản quyền thuộc về",

  // Accounts
  "nav.reportTemplates": "Báo cáo buổi học",
  "nav.revenue": "Doanh thu",
  "revenue.pageSubtitle":
    "Tổng quan doanh thu và các giao dịch gần đây của trung tâm.",
  "revenue.comingSoonTitle": "Tính năng đang phát triển",
  "revenue.comingSoonDesc":
    "Màn hình Doanh thu là một phần của lộ trình phát triển trong tương lai. Dữ liệu hiện tại chỉ mang tính minh hoạ để demo.",
  "revenue.demoDataBadge": "Dữ liệu demo",
  "revenue.demoDataNotice": "Dữ liệu demo",
  "revenue.totalRevenue": "Tổng doanh thu",
  "revenue.thisMonth": "Tháng này",
  "revenue.activeStudents": "Học viên đang học",
  "revenue.avgPerStudent": "Trung bình / học viên",
  "revenue.newStudents": "Học viên mới",
  "revenue.outstanding": "Công nợ phải thu",
  "revenue.outstandingHint": "Các khoản đang chờ xử lý",
  "revenue.monthlyChartTitle": "Doanh thu theo tháng",
  "revenue.monthlyChartSubtitle": "7 tháng gần nhất (VND)",
  "revenue.millionsShort": "{value}tr",
  "revenue.recentTransactions": "Giao dịch gần đây",
  "revenue.txId": "Mã giao dịch",
  "revenue.customer": "Khách hàng",
  "revenue.class": "Lớp học",
  "revenue.amount": "Số tiền",
  "revenue.method": "Phương thức",
  "revenue.status": "Trạng thái",
  "revenue.statusPaid": "Đã thanh toán",
  "revenue.statusPending": "Chờ xử lý",
  "revenue.statusRefunded": "Đã hoàn tiền",
  "revenue.methodCash": "Tiền mặt",
  "revenue.methodBank": "Chuyển khoản",
  "revenue.methodCard": "Thẻ",
  "revenue.methodMomo": "Ví MoMo",
  "nav.accounts": "Tài khoản",
  "accounts.title": "Quản lý tài khoản",
  "accounts.create": "Tạo tài khoản",
  "accounts.modalTitle": "Tạo tài khoản mới",
  "accounts.cancel": "Hủy",
  "accounts.creating": "Đang tạo...",
  "accounts.createError": "Tạo tài khoản thất bại",
  "accounts.empty": "Chưa có tài khoản nào",
  "accounts.colName": "HỌ TÊN",
  "accounts.colEmail": "EMAIL",
  "accounts.colRole": "VAI TRÒ",
  "accounts.colCenter": "TRUNG TÂM",
  "accounts.colCode": "MÃ",
  "accounts.colStatus": "TRẠNG THÁI",
  "accounts.active": "Hoạt động",
  "accounts.inactive": "Tạm khoá",
  "accounts.fieldName": "Họ tên",
  "accounts.fieldPassword": "Mật khẩu",
  "accounts.fieldRole": "Vai trò",
  "accounts.fieldPhone": "Số điện thoại",
  "accounts.fieldCode": "Mã tài khoản",

  // Common
  "common.close": "Đóng",

  // Session Notifications Modal
  "notify.sendBtn": "Gửi thông báo",
  "notify.modalTitle": "Gửi thông báo",
  "notify.titleLabel": "Tiêu đề",
  "notify.titleOptional": "(để trống dùng mặc định)",
  "notify.titlePlaceholder": "VD: Nhắc nhở buổi học hôm nay",
  "notify.messageLabel": "Nội dung",
  "notify.messagePlaceholder":
    "VD: Buổi học bắt đầu lúc 18:00 hôm nay. Vui lòng đến đúng giờ.",
  "notify.cancelBtn": "Hủy",
  "notify.sendingBtn": "Đang gửi...",
  "notify.sentPrefix": "Đã gửi thông báo đến",
  "notify.studentsSuffix": "học viên",
  "notify.sendFailed": "Gửi thông báo thất bại",
  "notify.newForeground": "Thông báo mới",

  // Notifications Page
  "notif.title": "Thông báo",
  "notif.filterAll": "Tất cả",
  "notif.filterUnread": "Chưa đọc",
  "notif.filterReminder": "Nhắc nhở",
  "notif.filterCancelled": "Đã hủy",
  "notif.filterUpdated": "Cập nhật",
  "notif.filterGeneral": "Chung",
  "notif.markRead": "Đánh dấu đã đọc",
  "notif.readAt": "Đã đọc lúc",
  "notif.showing": "Hiển thị",
  "notif.prev": "Trước",
  "notif.next": "Sau",
  "notif.viewAll": "Xem tất cả",

  // Change Password
  "nav.changePassword": "Đổi mật khẩu",

  // Common
  "common.soon": "Sắp có",

  // Export history (Tra cứu học viên)
  "exportHistory.openButton": "Xuất Excel",
  "exportHistory.title": "Xuất lịch sử học",
  "exportHistory.fromDate": "Từ ngày",
  "exportHistory.toDate": "Đến ngày",
  "exportHistory.scope": "Phạm vi xuất",
  "exportHistory.scopeAll": "Toàn bộ học viên của trung tâm",
  "exportHistory.scopeSelected": "Chọn cụ thể học viên",
  "exportHistory.searchPlaceholder": "Tìm theo tên, email, mã...",
  "exportHistory.submit": "Xuất file Excel",
  "exportHistory.exporting": "Đang xuất...",
  "common.cancel": "Hủy",
  "changePassword.title": "Đổi mật khẩu",
  "changePassword.currentPassword": "Mật khẩu hiện tại",
  "changePassword.currentPasswordPlaceholder": "Nhập mật khẩu hiện tại",
  "changePassword.newPassword": "Mật khẩu mới",
  "changePassword.newPasswordPlaceholder":
    "Nhập mật khẩu mới (tối thiểu 8 ký tự)",
  "changePassword.confirmPassword": "Nhập lại mật khẩu mới",
  "changePassword.confirmPasswordPlaceholder": "Nhập lại mật khẩu mới",
  "changePassword.submit": "Đổi mật khẩu",
  "changePassword.success": "Đổi mật khẩu thành công",
  "changePassword.errorPasswordMismatch": "Mật khẩu xác nhận không khớp",
  "changePassword.errorPasswordTooShort": "Mật khẩu phải có ít nhất 8 ký tự",
  "changePassword.errorCurrentPasswordRequired":
    "Vui lòng nhập mật khẩu hiện tại",

  // Trial Centers
  "trial.navTitle": "Dùng thử",
  "trial.title": "Quản lý tài khoản dùng thử",
  "trial.description":
    "Theo dõi và quản lý thời gian dùng thử của các trung tâm.",
  "trial.refresh": "Làm mới",
  "trial.filterAll": "Tất cả",
  "trial.filterActive": "Đang hoạt động",
  "trial.filterExpiringSoon": "Sắp hết hạn",
  "trial.filterExpired": "Đã hết hạn",
  "trial.centersFound": "trung tâm",
  "trial.emptyTitle": "Chưa có trung tâm dùng thử",
  "trial.emptyDescription": "Tạo trung tâm với thời gian dùng thử để bắt đầu.",
  "trial.colCenter": "Trung tâm",
  "trial.colManager": "Quản lý",
  "trial.colTrialEnd": "Ngày hết hạn",
  "trial.colDaysRemaining": "Còn lại",
  "trial.colUsers": "Người dùng",
  "trial.colStatus": "Trạng thái",
  "trial.colActions": "Thao tác",
  "trial.statusActive": "Đang dùng thử",
  "trial.statusExpiringSoon": "Sắp hết hạn",
  "trial.statusExpired": "Đã hết hạn",
  "trial.statusNoTrial": "Chưa dùng thử",
  "trial.setCustomDate": "Chọn ngày tùy chỉnh",
  "trial.setExpired": "Đặt hết hạn (chỉ đọc)",
  "trial.reactivate": "Kích hoạt lại (bỏ chỉ đọc)",
  "trial.resetTrial": "Xóa dùng thử (khôi phục mặc định)",
  "trial.confirmExpire":
    "Tất cả người dùng của trung tâm này sẽ chuyển sang chế độ chỉ đọc. Bạn có chắc chắn?",
  "trial.confirmReset":
    "Xóa hoàn toàn thông tin dùng thử? Trung tâm sẽ trở về trạng thái bình thường, không hạn chế.",
  "trial.rowsPerPage": "Hàng/trang",
  "trial.totalCenters": "trung tâm",
  "trial.prev": "Trước",
  "trial.next": "Tiếp",
  "trial.page": "Trang",

  // Send Notification Page
  "nav.centerSettings": "Trung tâm",
  "nav.sendNotification": "Gửi thông báo",
  "sendNotif.title": "Gửi thông báo",
  "sendNotif.targetByClass": "Theo lớp",
  "sendNotif.targetByUser": "Chọn người dùng",
  "sendNotif.selectClass": "Chọn lớp học",
  "sendNotif.selectClassPlaceholder": "-- Chọn lớp --",
  "sendNotif.roleLabel": "Vai trò",
  "sendNotif.roleStudent": "Học viên",
  "sendNotif.roleTeacher": "Quản lý lớp",
  "sendNotif.roleTrainer": "Huấn luyện viên",
  "sendNotif.roleStaff": "Quản lý trung tâm",
  "sendNotif.userList": "Danh sách người dùng",
  "sendNotif.selectAll": "Chọn tất cả",
  "sendNotif.deselectAll": "Bỏ chọn tất cả",
  "sendNotif.noUsers": "Không có người dùng",
  "sendNotif.searchPlaceholder": "Tìm theo tên, email...",
  "sendNotif.titleLabel": "Tiêu đề",
  "sendNotif.titlePlaceholder": "Nhập tiêu đề thông báo",
  "sendNotif.messageLabel": "Nội dung",
  "sendNotif.messagePlaceholder": "Nhập nội dung thông báo",
  "sendNotif.sendBtn": "Gửi thông báo",
  "sendNotif.sendingBtn": "Đang gửi...",
  "sendNotif.success": "Đã gửi thông báo đến {count} người",
  "sendNotif.error": "Gửi thông báo thất bại",
  "sendNotif.noRecipients": "Vui lòng chọn ít nhất một người dùng",
  "sendNotif.noTitle": "Vui lòng nhập tiêu đề",
  "sendNotif.noMessage": "Vui lòng nhập nội dung",
  "sendNotif.selected": "đã chọn",

  // Self Check-in
  "nav.selfCheckin": "Tự điểm danh",
  "selfCheckin.title": "Tự điểm danh bằng khuôn mặt",
  "selfCheckin.selectSession": "Chọn buổi học",
  "selfCheckin.noSession": "— Không chọn buổi học —",
  "selfCheckin.cameraOff": "Nhấn nút bên dưới để mở camera",
  "selfCheckin.openCamera": "Mở camera",
  "selfCheckin.capture": "Chụp ảnh",
  "selfCheckin.cancel": "Hủy",
  "selfCheckin.submit": "Xác nhận điểm danh",
  "selfCheckin.submitting": "Đang xử lý...",
  "selfCheckin.retake": "Chụp lại",
  "selfCheckin.checkedIn": "Điểm danh vào thành công!",
  "selfCheckin.checkedOut": "Điểm danh ra thành công!",
  "selfCheckin.matchSuccess": "Xác nhận khuôn mặt thành công",
  "selfCheckin.noMatch": "Không nhận diện được khuôn mặt",
  "selfCheckin.error": "Có lỗi xảy ra, vui lòng thử lại",
  "selfCheckin.cameraError": "Không thể truy cập camera",
  "selfCheckin.loadSessionError": "Không thể tải danh sách buổi học",
  "selfCheckin.resultMatched": "Khuôn mặt khớp!",
  "selfCheckin.resultNotMatched": "Không nhận diện được",
  "selfCheckin.score": "Độ chính xác",
  "selfCheckin.attendanceStatus": "Trạng thái điểm danh",
  "selfCheckin.statusCheckedIn": "Đã điểm danh vào",
  "selfCheckin.statusCheckedOut": "Đã điểm danh ra",
  "selfCheckin.checkedInAt": "Giờ vào",
  "selfCheckin.checkedOutAt": "Giờ ra",

  // Student schedule dashboard
  "mySchedule.title": "Lịch học của tôi",
  "mySchedule.loading": "Đang tải dữ liệu học tập...",
  "mySchedule.notScheduled": "Chưa xếp lịch",
  "mySchedule.calendar": "Calendar lớp học",
  "mySchedule.today": "Hôm nay",
  "mySchedule.month": "Tháng",
  "mySchedule.week": "Tuần",
  "mySchedule.list": "Danh sách",
  "mySchedule.myCourses": "Lớp học đang tham gia (bấm để xem chi tiết)",
  "mySchedule.classCode": "Mã lớp",
  "mySchedule.remainingSessions": "Số buổi còn lại",
  "mySchedule.instructor": "Giảng viên",
  "mySchedule.notAssigned": "Chưa phân công",
  "mySchedule.noCourses": "Bạn chưa tham gia lớp học nào.",
  "mySchedule.checkin": "Điểm danh",
  "mySchedule.byDate": "Lịch học theo ngày",
  "mySchedule.fromDate": "Từ ngày",
  "mySchedule.toDate": "Đến ngày",
  "mySchedule.dateRangeError": "Ngày bắt đầu phải trước ngày kết thúc",
  "mySchedule.loadingSessions": "Đang tải...",
  "mySchedule.noSessions": "Không có buổi học nào",
  "mySchedule.sessionsCount": "buổi học",
  "mySchedule.class": "Lớp",
  "mySchedule.courseDetail": "Chi tiết lớp học",
  "mySchedule.courseInfo": "Thông tin lớp học",
  "mySchedule.courseName": "Tên khóa",
  "mySchedule.totalSessions": "Tổng số buổi",
  "mySchedule.center": "Trung tâm",
  "mySchedule.noDescription": "Chưa có mô tả lớp học.",
  "mySchedule.instructorInCharge": "Quản lý lớp phụ trách",
  "mySchedule.noBio": "Chưa có giới thiệu.",
  "mySchedule.achievement": "Thành tích",
  "mySchedule.certificate": "Chứng chỉ",

  // Attendance history
  "nav.attendanceHistory": "Lịch sử điểm danh",
  "attendanceHistory.title": "Lịch sử điểm danh",
  "attendanceHistory.loading": "Đang tải lịch sử điểm danh...",
  "attendanceHistory.empty": "Chưa có lịch sử điểm danh nào.",
  "attendanceHistory.checkedInAt": "Giờ vào",
  "attendanceHistory.checkedOutAt": "Giờ ra",
  "attendanceHistory.method": "Phương thức",
  "attendanceHistory.status": "Trạng thái",
  "attendanceHistory.notes": "Ghi chú",
  "attendanceHistory.methodFace": "Khuôn mặt",
  "attendanceHistory.methodManual": "Thủ công",
  "attendanceHistory.statusCheckedIn": "Đã điểm danh vào",
  "attendanceHistory.statusCheckedOut": "Đã điểm danh ra",
  "attendanceHistory.statusAbsent": "Vắng",
  "attendanceHistory.statusExcused": "Nghỉ phép",
  "attendanceHistory.notAvailable": "—",
  "attendanceHistory.loadError": "Không thể tải lịch sử điểm danh",
  "attendanceHistory.loadMore": "Tải thêm",
  "attendanceHistory.totalSessions": "Tổng buổi",
  "attendanceHistory.checkedInCount": "Đã điểm danh",
  "attendanceHistory.absentCount": "Vắng",
  "attendanceHistory.excusedCount": "Nghỉ phép",
  "attendanceHistory.date": "Ngày",
  "attendanceHistory.detailTitle": "Chi tiết điểm danh",
  "attendanceHistory.checkInPhoto": "Ảnh điểm danh vào",
  "attendanceHistory.checkOutPhoto": "Ảnh điểm danh ra",
  "attendanceHistory.noPhoto": "Không có ảnh",
  "attendanceHistory.checkInLocation": "Vị trí điểm danh vào",
  "attendanceHistory.checkOutLocation": "Vị trí điểm danh ra",
  "attendanceHistory.noLocation": "Không có vị trí",
  "attendanceHistory.resolvingAddress": "Đang tra cứu địa chỉ...",
  "attendanceHistory.recordNotFound":
    "Không tìm thấy bản ghi điểm danh cho buổi học này.",
  "attendanceHistory.viewOnGoogleMaps": "Xem trên Google Maps",
  "attendanceHistory.tabByMonth": "Theo tháng",
  "attendanceHistory.tabAll": "Tất cả",
  "attendanceHistory.className": "Tên lớp",
  "attendanceHistory.session": "Buổi",
  "attendanceHistory.monthGroupPrefix": "Tháng",
  "attendanceHistory.viewDetails": "Xem chi tiết",
  "attendanceHistory.sortNewest": "Mới nhất",
  "attendanceHistory.sortOldest": "Cũ nhất",
  "attendanceHistory.emptyMonth": "Không có buổi học nào trong tháng này.",
  "attendanceHistory.photos": "Hình ảnh",
  "attendanceHistory.locations": "Vị trí",
  "attendanceHistory.hasPhoto": "Có ảnh điểm danh",

  // Student classes / sessions page
  "nav.classes": "Lớp học của tôi",
  "classesPage.title": "Lớp học của tôi",
  "classesPage.loading": "Đang tải danh sách lớp học...",
  "classesPage.myCourses":
    "Lớp học đang tham gia (bấm để xem danh sách buổi học)",
  "classesPage.classCode": "Mã lớp",
  "classesPage.remainingSessions": "Số buổi còn lại",
  "classesPage.instructor": "Giảng viên",
  "classesPage.notAssigned": "Chưa phân công",
  "classesPage.noCourses": "Bạn chưa tham gia lớp học nào.",
  "classesPage.sessionsTitle": "Danh sách buổi học (bấm để xem chi tiết)",
  "classesPage.noSessions": "Lớp học này chưa có buổi học nào.",
  "classesPage.notScheduled": "Chưa xếp lịch",
  "classesPage.center": "Trung tâm",
  "classesPage.period": "Thời gian học",
  "classesPage.statusOpening": "Đang mở",
  "classesPage.statusOngoing": "Đang học",
  "classesPage.statusClosed": "Đã kết thúc",
  "classesPage.instructorInfo": "Thông tin giảng viên",
  "classesPage.bio": "Giới thiệu",
  "classesPage.achievement": "Thành tích",
  "classesPage.certificate": "Chứng chỉ",
  "classesPage.upcomingSessions": "Sắp tới",
  "classesPage.pastSessions": "Đã qua",
  "classesPage.sessionStatusScheduled": "Đã lên lịch",
  "classesPage.sessionStatusActive": "Đang diễn ra",
  "classesPage.sessionStatusCompleted": "Đã kết thúc",
  "classesPage.sessionStatusCancelled": "Đã hủy",

  // Read-only session detail (opened from a session row)
  "sessionDetail.title": "Chi tiết buổi học",
  "sessionDetail.loading": "Đang tải thông tin buổi học...",
  "sessionDetail.loadError": "Không thể tải thông tin buổi học",
  "sessionDetail.time": "Thời gian",
  "sessionDetail.location": "Địa điểm",
  "sessionDetail.manager": "Quản lý lớp (QLL)",
  "sessionDetail.trainer": "Huấn luyện viên (HLV)",
  "sessionDetail.noManager": "Chưa phân công quản lý lớp",
  "sessionDetail.noTrainer": "Chưa phân công huấn luyện viên",
  "sessionDetail.checkin": "Mở camera điểm danh",
  "sessionDetail.leaveRequest": "Xin nghỉ phép",
  "sessionDetail.requestLeave": "Xin nghỉ phép",
  "sessionDetail.leaveReasonPlaceholder": "Nhập lý do xin nghỉ...",
  "sessionDetail.submitLeave": "Gửi đơn",
  "sessionDetail.saveLeave": "Lưu",
  "sessionDetail.cancelLeave": "Hủy",
  "sessionDetail.editLeave": "Sửa đơn",
  "sessionDetail.withdrawLeave": "Xóa đơn",
  "sessionDetail.leavePending": "Đã gửi đơn, đang chờ duyệt",
  "sessionDetail.leaveApproved": "Đã được duyệt nghỉ phép",
  "sessionDetail.leaveRejected": "Đơn bị từ chối",
  "sessionDetail.leaveError": "Không thể gửi đơn xin nghỉ phép",

  // Audit log management
  "audit.navTitle": "Quản lý nhật ký",
  "audit.title": "Quản lý nhật ký hệ thống",
  "audit.subtitle":
    "Theo dõi các thao tác và thay đổi quan trọng trên toàn hệ thống.",
  "audit.actorEmail": "Email người thực hiện",
  "audit.actionType": "Loại thao tác",
  "audit.entityType": "Loại đối tượng",
  "audit.allResults": "Tất cả kết quả",
  "audit.success": "Thành công",
  "audit.failed": "Thất bại",
  "audit.dateFrom": "Từ ngày",
  "audit.dateTo": "Đến ngày",
  "audit.clear": "Xóa bộ lọc",
  "audit.filter": "Lọc nhật ký",
  "audit.total": "Tổng nhật ký",
  "audit.refresh": "Tải lại",
  "audit.time": "Thời gian",
  "audit.actor": "Người thực hiện",
  "audit.entity": "Đối tượng",
  "audit.result": "Kết quả",
  "audit.sourceIp": "Địa chỉ IP",
  "audit.details": "Chi tiết",
  "audit.loading": "Đang tải nhật ký...",
  "audit.empty": "Không tìm thấy nhật ký phù hợp.",
  "audit.loadError": "Không thể tải nhật ký hệ thống.",
  "audit.system": "Hệ thống",
  "audit.viewDetails": "Xem chi tiết",
  "audit.page": "Trang",
  "audit.detailTitle": "Chi tiết nhật ký",
  "audit.requestId": "Mã yêu cầu",
  "audit.userAgent": "Thiết bị / trình duyệt",
  "audit.reason": "Lý do",
  "audit.errorMessage": "Thông báo lỗi",
  "audit.beforeState": "Dữ liệu trước thay đổi",
  "audit.afterState": "Dữ liệu sau thay đổi",
  "audit.changedFields": "Các trường đã thay đổi",

  // Session attendance report
  "sessionAttendanceReport.title": "Báo cáo điểm danh",
  "sessionAttendanceReport.subtitle":
    "Tổng hợp điểm danh của buổi học theo từng nhóm.",
  "sessionAttendanceReport.attendanceRate": "Tỷ lệ tham gia",
  "sessionAttendanceReport.students": "Học viên",
  "sessionAttendanceReport.staff": "Nhân viên",
  "sessionAttendanceReport.export": "Xuất báo cáo Excel",
  "sessionAttendanceReport.attended": "Đã tham gia",
  "sessionAttendanceReport.checkedIn": "Đang có mặt",
  "sessionAttendanceReport.checkedOut": "Đã ra về",
  "sessionAttendanceReport.absent": "Vắng mặt",
  "sessionAttendanceReport.excused": "Vắng có phép",
  "sessionAttendanceReport.unmarked": "Chưa điểm danh",
  "sessionAttendanceReport.person": "Họ tên",
  "sessionAttendanceReport.role": "Vai trò",
  "sessionAttendanceReport.status": "Trạng thái",
  "sessionAttendanceReport.checkIn": "Giờ vào",
  "sessionAttendanceReport.checkOut": "Giờ ra",
  "sessionAttendanceReport.checkInBadge": "Vào",
  "sessionAttendanceReport.checkOutBadge": "Ra",
  "sessionAttendanceReport.empty": "Chưa có người tham gia trong nhóm này.",

  // Report field - multiple files
  "reportField.addFile": "Thêm file",
  "reportField.removeFile": "Xóa file",
  "reportField.maxFilesReached": "Đã đạt giới hạn số file tối đa",
  "reportField.confirmDeleteFile": "Bạn có chắc muốn xóa file này?",
  "reportField.uploadedFiles": "File đã tải lên",
  "reportField.pendingFiles": "File chờ tải lên",

  // Leave requests (QLL duyệt đơn xin nghỉ phép)
  "leaveRequests.title": "Đơn xin nghỉ phép",
  "leaveRequests.description":
    "Xem và duyệt đơn xin nghỉ phép của học viên theo từng lớp phụ trách.",
  "leaveRequests.classLabel": "Lớp",
  "leaveRequests.allClasses": "Tất cả lớp",
  "leaveRequests.noClasses": "Không có lớp nào",
  "leaveRequests.filterAll": "Tất cả",
  "leaveRequests.statusPending": "Đang chờ duyệt",
  "leaveRequests.statusApproved": "Đã duyệt",
  "leaveRequests.statusRejected": "Đã từ chối",
  "leaveRequests.loading": "Đang tải danh sách đơn...",
  "leaveRequests.loadError": "Không thể tải danh sách đơn xin nghỉ phép",
  "leaveRequests.reviewError": "Không thể xử lý đơn xin nghỉ phép",
  "leaveRequests.empty": "Chưa có đơn xin nghỉ phép nào.",
  "leaveRequests.submittedAt": "Gửi lúc",
  "leaveRequests.notScheduled": "Chưa rõ buổi học",
  "leaveRequests.reviewedBy": "Người duyệt",
  "leaveRequests.columnIndex": "STT",
  "leaveRequests.columnStudent": "Học viên",
  "leaveRequests.columnSession": "Lớp / Buổi học",
  "leaveRequests.columnReason": "Lý do",
  "leaveRequests.columnSubmittedAt": "Gửi lúc",
  "leaveRequests.columnReviewer": "Người duyệt",
  "leaveRequests.columnStatus": "Trạng thái",
  "leaveRequests.columnActions": "Hành động",
  "leaveRequests.thisWeekOnly": "Chỉ tuần này",
  "leaveRequests.showAll": "Xem tất cả",
  "leaveRequests.approve": "Đồng ý",
  "leaveRequests.reject": "Từ chối",
  "leaveRequests.resetToPending": "Chuyển về chờ duyệt",
  "leaveRequests.notAllowed": "Bạn không có quyền truy cập trang này.",
};

export default vi;
